import {isSamePeriod} from '../../../../utils/helper'
import {normalizePeriod} from '../../../../utils/formatter'
import store from '../../../../store'

export const makeEmptyHotelFilter = () => {
  return {
    rating: null,
    prezzo: null,
    nome: null
  }
}

export const makeHotels = function (state, payload) {
  payload.forEach(item => {
    // normalizza il periodo
    item.period = normalizePeriod(item.period)

    item.list.forEach(hotel => {
      // normalizza periodo
      hotel.period = normalizePeriod(item.period)

      // estrae tutti i travel groups
      const groupIds = new Set(hotel.rooms.map(room => { return room.availabilityData.travelGroupId }))
      let groups = []
      groupIds.forEach(id => {
        groups.push({
          travelGroupId: id,
          rooms: hotel.rooms.filter(function (room) {
            return room.availabilityData.travelGroupId === id
          })
        })
      })
      hotel.groups = groups

      // aggiunge l'attributo selected alle room e seleziona la prima di ogni gruppo
      hotel.venditaTotaleEuroBase = 0
      hotel.venditaTotaleEuro = 0
      hotel.groups.forEach(group => {
        group.rooms.forEach((room, index) => {
          room.selected = index === 0
        })
        hotel.venditaTotaleEuroBase += group.rooms[0].price.venditaTotaleEuro
        hotel.venditaTotaleEuro += group.rooms[0].price.venditaTotaleEuro
      })

      // aggancia le configurazioni
      const config = store.getters.getHotels.list.find(item => {
        const codice = item.codice
        const fornitore = item.fornitore.name
        const {code, provider} = hotel.hotel.location.id
        return codice.trim() === code.trim() && fornitore === provider
      })

      // rimpiazza il nome della location con il nome della configurazione
      if (config && config.nome) {
        hotel.hotel.location.name = config.nome
        hotel.hotel.config = config
      }
    })
  })

  // ordina venditaTotaleEuroBase
  payload.forEach(item => {
    item.list = item.list.sort(function (a, b) {
      return a.venditaTotaleEuroBase - b.venditaTotaleEuroBase
    })
  })

  // seleziona il primo hotel del periodo
  payload.forEach(item => {
    item.selected = []
    item.selected.push(item.list[0])
  })
  return payload
}

export const addReplaceHotel = (state, hotel) => {
  const periodIndex = state.hotels.list.findIndex(item => {
    return isSamePeriod(item.period, hotel.period)
  })
  let list = state.hotels.list[periodIndex].selected
  if (list.length === 0) {
    list.push({...hotel})
  } else {
    list.splice(0, 1, {...hotel})
  }
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/hotels.js